import React from "react";
import useHeaderHeight, {
  FAULT_EVENT_HEADER_HEIGHT_CSS_VARIABLE,
  FAULT_EVENT_NAVIGATION_HEIGHT_CSS_VARIABLE,
  PRIMARY_HEADER_HEIGHT_CSS_VARIABLE,
} from "@ui/Header/useHeaderHeight";
import { css } from "@linaria/core";
import { colors, spacings } from "@ui/Theme";

const Header = ({
  titleHeader,
  cards: { resumeCard, lastCommentCard, actionIdentifiedCard },
  navigation,
}: {
  titleHeader: React.ReactNode;
  cards: {
    resumeCard: React.ReactNode;
    lastCommentCard?: React.ReactNode;
    actionIdentifiedCard?: React.ReactNode;
  };
  navigation: React.ReactNode | null;
}) => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const navigationRef = React.useRef<HTMLDivElement>(null);
  useHeaderHeight(headerRef, FAULT_EVENT_HEADER_HEIGHT_CSS_VARIABLE);
  useHeaderHeight(navigationRef, FAULT_EVENT_NAVIGATION_HEIGHT_CSS_VARIABLE);

  return (
    <>
      <div ref={headerRef} className={titleSticky}>
        {titleHeader}
      </div>
      <div className={cards}>
        <div className={card}>{resumeCard}</div>
        {lastCommentCard && <div className={card}>{lastCommentCard}</div>}
        {actionIdentifiedCard && <div className={card}>{actionIdentifiedCard}</div>}
      </div>
      {navigation && (
        <div ref={navigationRef} className={navigationHeaderSticky}>
          {navigation}
        </div>
      )}
    </>
  );
};

export default Header;

//#region CSS
const titleSticky = css`
  position: sticky;
  z-index: 3;
  top: var(${PRIMARY_HEADER_HEIGHT_CSS_VARIABLE});
  background-color: ${colors.hydrogen};

  & > :nth-child(2) {
    margin: 0 ${spacings.xxl};
  }
`;

const cards = css`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  grid-template-rows: 1fr;
  @media (max-width: 1080px) {
    grid-template-columns: repeat(1, 1fr);
  }
  gap: ${spacings.m};
  margin: ${spacings.m} ${spacings.xxl};
`;
const card = css`
  padding: ${spacings.m};
  border-radius: ${spacings.xxs};
  border: 1px solid ${colors.titanium200};
  background-color: ${colors.hydrogen};
`;

const navigationHeaderSticky = css`
  padding: 0 ${spacings.xxl};

  position: sticky;
  z-index: 3;
  top: calc(
    var(${PRIMARY_HEADER_HEIGHT_CSS_VARIABLE}) + var(${FAULT_EVENT_HEADER_HEIGHT_CSS_VARIABLE})
  );

  & > :last-child {
    padding-top: 16px;
  }

  & > :first-child {
    border-bottom: 1px solid;
    border-bottom-color: ${colors.titanium200};
  }
`;
//#endregion CSS
